import React from 'react';

// The ActiveOptics mark: a rising line on a blue tile. Same geometry as
// public/favicon.svg and the phone app's icon, inlined so it scales crisply
// and needs no extra request. Decorative — the text next to it carries the name.
export default function BrandMark({ size = 32, className = '' }) {
  return (
    <svg
      className={`brand-mark ${className}`.trim()}
      viewBox="0 0 64 64"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id="brand-mark-g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#3b82f6" />
          <stop offset="1" stopColor="#1d4ed8" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="15" fill="url(#brand-mark-g)" />
      <path d="M13 44 L26 31 L35 38 L50 20" fill="none" stroke="#fff" strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M40 19 H51 V30" fill="none" stroke="#fff" strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="13" cy="44" r="4" fill="#fff" />
    </svg>
  );
}
